<template>
  <div>
    <a-layout-content style="padding: 0 20px">
      <div class="w-full mt-4 fac-box p-3">
        <div class="w-full flex items-center">
          <div class="freqx_formTitle" style="width: 200px">{{ getLanguage('基础配置') }}</div>
        </div>

        <div class="w-full flex flex-wrap">
          <div
            style="margin-right: 20px; width: 600px"
            class="mt-4"
            v-for="(item, index) in factoryListAll"
            :key="index"
          >
            <div class="facInfo p-4" style="padding-top: 5px">
              <div class="w-full flex mb-2">
                <div class="flex-1"></div>
                <a-popconfirm
                  title="Delete this factory?"
                  ok-text="Confirm"
                  cancel-text="Cancel"
                  @confirm="deleteFactory(index)"
                >
                  <div class="cursor-pointer">
                    <close-square-outlined
                      style="font-size: 20px; margin-left: 10px; color: #fff"
                    />
                  </div>
                </a-popconfirm>
              </div>
              <a-form
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
                autocomplete="off"
              >
                <a-form-item label="Parent Factory">
                  <!-- <a-input v-model:value="item.parentName" readonly/> -->
                  <a-select
                    ref="select"
                    v-model:value="item.parentId"
                    allowClear
                  >
                    <a-select-option
                      v-for="(item, index) in boldList"
                      :key="index"
                      :value="item._id"
                      >{{ item.factoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="Factory Name">
                  <a-input v-model:value="item.factoryName" />
                </a-form-item>

                <a-form-item label="Zone">
                  <div
                    class="w-full mt-2"
                    v-for="(group, index2) in item.groups"
                    :key="index2"
                  >
                    <div class="w-full flex items-center">
                      <a-input v-model:value="group.name" />
                      <a-input
                        style="margin-left: 10px"
                        v-model:value="group.sonID"
                        readonly
                      />
                      <div
                        class="cursor-pointer"
                        @click="deleteGroup(item.groups, index2)"
                      >
                        <close-square-outlined
                          style="
                            font-size: 20px;
                            margin-left: 10px;
                            color: #fff;
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <a-button class="mt-2" style="background-color: #fff;" @click="addGroup(item.groups)">
                    <template #icon>
                      <plus-outlined />
                    </template>
                    {{ getLanguage('新增') }}
                  </a-button>
                </a-form-item>
              </a-form>
            </div>
          </div>
        </div>

        <div class="w-full flex items-center mt-3">
          <a-button type="primary" @click="addFactory">{{ getLanguage('新增') }}</a-button>
          <a-button class="ml-2" type="primary" @click="saveFactory"
            >{{ getLanguage('保存') }}
          </a-button>
        </div>
      </div>

      <div class="w-full mt-4 fac-box p-3">
        <a-form
          :model="diagnosisForm"
          name="diagnosisForm"
          autocomplete="off"
          layout="inline"
          :label-col="{ style: { width: '100px' } }"
        >
          <div class="w-full flex items-center">
            <div class="freqx_formTitle fff" >
              {{ getLanguage('设备诊断配置') }}
            </div>
          </div>

          <div class="w-full">
            <a-tabs
              v-model:activeKey="factorySettingTabActiveKey"
              @change="onChangeFactorySettingTab"
            >
              <a-tab-pane :key="key" v-for="(item, key) in factoryList">
                <template #tab>
                  <span>
                    <bank-outlined />
                    {{ getTranslation(item.factoryName) }}
                  </span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>

          <div class="code-box-meta markdown">
            <div class="code-box-title">{{ getLanguage('指标监测') }}</div>
            <div class="code-box-description">
              <a-form-item :label-col="{ style: { width: '120px' } }" :label="getLanguage('默认数据类型')" name="defaultDataTypes">
                <a-select
                  style="min-width: 500px"
                  v-model:value="diagnosisForm.diagnosisRule.defaultDataTypes"
                  mode="multiple"
                  :options="dataTypes"
                ></a-select>
              </a-form-item>
            </div>
          </div>
        </a-form>
        <a-button type="primary" @click="saveDiagnosisRules">{{ getLanguage('保存') }}</a-button>
      </div>

      <div class="w-full mt-4 fac-box p-3">
        <a-form
          :model="reportRuleForm"
          name="basic"
          autocomplete="off"
          layout="inline"
          :label-col="{ style: { width: '100px' } }"
        >
          <div class="w-full flex items-center">
            <div class="freqx_formTitle fff">
              {{ getLanguage('周报月报配置') }}
            </div>
          </div>

          <div class="w-full">
            <a-tabs
              v-model:activeKey="factorySettingTabActiveKey"
              @change="onChangeFactorySettingTab"
            >
              <a-tab-pane :key="key" v-for="(item, key) in factoryList">
                <template #tab>
                  <span>
                    <bank-outlined />
                    {{ getTranslation(item.factoryName) }}
                  </span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>

          <div class="code-box-meta markdown">
            <div class="code-box-title" style="background: #080718ff">
              {{ getLanguage('报告生成策略') }}
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('是否生成报告')" name="alarmTactics">
                <span class="flex">
                  <a-radio-group
                    name="radioGroup"
                    v-model:value="reportRuleForm.reportRule.enabled"
                  >
                    <a-radio :value="false">{{getLanguage('否')}}</a-radio>
                    <a-radio :value="true">{{getLanguage('是')}}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item label="" name="deadline">
                <span class="fff">{{getLanguage('每月第')}}</span>&nbsp;&nbsp;<a-input-number
                  :min="1"
                  max="28"
                  :disabled="!reportRuleForm.reportRule.enabled"
                  v-model:value="reportRuleForm.reportRule.dayOfMonth"
                />&nbsp;&nbsp;<span class="fff">{{getLanguage('天生成月报')}}</span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                <span class="fff">{{getLanguage('每周第')}}</span>&nbsp;&nbsp;<a-input-number
                  :min="0"
                  max="6"
                  :disabled="!reportRuleForm.reportRule.enabled"
                  v-model:value="reportRuleForm.reportRule.dayOfWeek"
                />&nbsp;&nbsp;<span class="fff">{{getLanguage('天生成周报')}}( {{getLanguage('范围')}} 0 - 6)</span>
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item label="" name="deadline">
                <span class="fff">{{getLanguage('第')}}</span>&nbsp;&nbsp;<a-input-number
                  :min="0"
                  max="23"
                  :disabled="!reportRuleForm.reportRule.enabled"
                  v-model:value="reportRuleForm.reportRule.dayOfHour"
                />&nbsp;&nbsp;<span class="fff">{{getLanguage('小时生成报告')}}</span>
              </a-form-item>
            </div>
          </div>
        </a-form>
        <a-button type="primary" @click="saveReportRuleSettings">{{getLanguage('保存')}}</a-button>
      </div>

      <div class="w-full mt-4 fac-box p-3">
        <a-form
          :model="diagnosisForm"
          name="diagnosisForm"
          autocomplete="off"
          layout="inline"
          :label-col="{ style: { width: '140px' } }"
        >
          <div class="w-full flex items-center">
            <div class="freqx_formTitle fff" style="width: 200px">
              {{getLanguage('推送账号配置')}}
            </div>
          </div>

          <div class="w-full">
            <a-tabs
              v-model:activeKey="factorySettingTabActiveKey"
              @change="onChangeFactorySettingTab"
            >
              <a-tab-pane :key="key" v-for="(item, key) in factoryList">
                <template #tab>
                  <span>
                    <bank-outlined />
                    {{ getTranslation(item.factoryName) }}
                  </span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>

          <div class="code-box-meta markdown">
            <div class="code-box-title">{{getLanguage('企业微信')}}</div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('企业id')" name="corpId">
                <a-input v-model:value="workWxForm.workWxSettings.corpId" />
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('企业secret')" name="corpSecret">
                <a-input v-model:value="workWxForm.workWxSettings.corpSecret" />
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('应用AgentId')" name="agentId">
                <a-input v-model:value="workWxForm.workWxSettings.agentId" />
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('群聊id')" name="chatId">
                <a-input v-model:value="workWxForm.workWxSettings.chatId" />
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('消息标题')" name="messageTitle">
                <a-input v-model:value="workWxForm.workWxSettings.messageTitle"/>
              </a-form-item>
            </div>
       
          </div>

        </a-form>
        <a-button type="primary" @click="saveWorkWxForm">{{ getLanguage('保存') }}</a-button>
      </div>

      <div class="w-full mt-4 fac-box p-3">
        <a-form
          :model="systemInfo"
          name="basic"
          autocomplete="off"
          layout="inline"
          :label-col="{ style: { width: '120px' } }"
        >
          <div class="w-full flex items-center">
            <div class="freqx_formTitle fff">
              {{ getLanguage('安全策略配置') }}
            </div>
          </div>
          <div class="code-box-meta markdown">
            <div class="code-box-title" style="background: #080718ff">
              {{ getLanguage('账号策略') }}
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('图形码验证')" name="captcha">
                <span class="flex">
                  <a-radio-group
                    name="captcha"
                    v-model:value="systemInfo.captcha"
                  >
                    <a-radio :value="true">{{ getLanguage('启用') }}</a-radio>
                    <a-radio :value="false">{{ getLanguage('关闭') }}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('错误锁定')" name="errorPwdLock">
                <span class="flex">
                  <a-radio-group
                    name="errorPwdLock"
                    v-model:value="systemInfo.errorPwdLock"
                  >
                    <a-radio :value="true">{{ getLanguage('启用') }}</a-radio>
                    <a-radio :value="false">{{ getLanguage('关闭') }}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                <span class="fff">{{ getLanguage('第2') }}</span>&nbsp;&nbsp;<a-input-number
                  :disabled="!systemInfo.errorPwdLock"
                  v-model:value="systemInfo.errorPwdCount"
                />&nbsp;&nbsp;<span class="fff">{{ getLanguage('账号密码验证错误次后锁定') }}</span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                &nbsp;&nbsp;<a-input-number
                  :disabled="!systemInfo.errorPwdLock"
                  v-model:value="systemInfo.errorPwdLockSecond"
                />&nbsp;&nbsp;<span class="fff">{{ getLanguage('秒') }}</span>
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('自动登出')" name="autoLogout">
                <span class="flex">
                  <a-radio-group
                    name="autoLogout"
                    v-model:value="systemInfo.autoLogout"
                  >
                    <a-radio :value="true">{{ getLanguage('启用') }}</a-radio>
                    <a-radio :value="false">{{ getLanguage('关闭') }}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                <span class="fff">{{ getLanguage('当') }}</span>&nbsp;&nbsp;<a-input-number
                  :disabled="!systemInfo.autoLogout"
                  v-model:value="systemInfo.autoLogoutSecond"
                />&nbsp;&nbsp;<span class="fff">{{ getLanguage('秒用户未操作时自动登出') }}</span>
              </a-form-item>
            </div>
            <div class="code-box-description">
              <a-form-item :label="getLanguage('密码强制过期')" name="pwdExpire">
                <span class="flex">
                  <a-radio-group
                    name="pwdExpire"
                    v-model:value="systemInfo.pwdExpire"
                  >
                    <a-radio :value="true">{{ getLanguage('启用') }}</a-radio>
                    <a-radio :value="false">{{ getLanguage('关闭') }}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                <span class="fff">{{ getLanguage('当') }}</span>&nbsp;&nbsp;<a-input-number
                  :disabled="!systemInfo.pwdExpire"
                  v-model:value="systemInfo.pwdExpireDay"
                />&nbsp;&nbsp;<span class="fff">{{ getLanguage('天后用户需强制修改密码') }}</span>
              </a-form-item>
            </div>

            <div class="code-box-description">
              <a-form-item :label="getLanguage('密码历史限制')" name="pwdExpire">
                <span class="flex">
                  <a-radio-group
                    name="pwdHistory"
                    v-model:value="systemInfo.pwdHistory"
                  >
                    <a-radio :value="true">{{ getLanguage('启用') }}</a-radio>
                    <a-radio :value="false">{{ getLanguage('关闭') }}</a-radio>
                  </a-radio-group>
                </span>
              </a-form-item>
              <a-form-item label="" name="deadline">
                <span class="fff">{{ getLanguage('不能设置') }}</span>&nbsp;&nbsp;<a-input-number
                  :disabled="!systemInfo.pwdHistory"
                  v-model:value="systemInfo.pwdHistoryDay"
                />&nbsp;&nbsp;<span class="fff">{{ getLanguage('天使用过的密码') }}</span>
              </a-form-item>
            </div>
          </div>
        </a-form>
        <a-button type="primary" @click="saveSystemSetting">{{ getLanguage('保存') }}</a-button>
      </div>

    </a-layout-content>
  </div>
</template>

<script lang="ts" setup>
import request from "../../common/request";
import { transformDate } from "@/common/tools";
import { onMounted } from "vue";
import { ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage, getTranslation } from "@/common/translate";

operateLogs("访问基础配置");
/**操作日志记录 */

onMounted(() => {
  loadDatatype();
});

let dataTypes = ref<{ value: string; label: string }>();
const loadDatatype = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/sensors/datatype", config).then((res: any) => {
    if (res) {
      dataTypes.value = res.data.map((t: any) => ({
        value: t.name,
        label: t.name,
      }));
    }
  });
};

class DiagnosisRule {
  defaultDataTypes: string[] = [];
}

class ReportRule {
  enabled: boolean = true;
  dayOfMonth: number = 1;
  dayOfWeek: number = 5;
  dayOfHour: number = 12;
}

class WorkWxSettings {
  messageTitle: string = "";
  chatId: string = "";
  agentId: string = "";
  corpId: string = "";
  corpSecret: string = "";
}

interface FactorySettings {
  id?: string | null;
  factoryId: string | null;
  diagnosisRule: DiagnosisRule;
  reportRule: ReportRule;
  workWxSettings: WorkWxSettings;
}

let factorySettingTabActiveKey = ref<any>(0);
let diagnosisForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "diagnosisRule">
>({
  id: null,
  factoryId: null,
  diagnosisRule: new DiagnosisRule(),
});
let onChangeFactorySettingTab = (key: number) => {
  let selectFact = factoryList.value[key];
  getFactorySettings(selectFact._id);
};

const getFactorySettings = (factoryId: string) => {
  const config = {
    params: { id: factoryId },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories/setting", config).then((res: any) => {
    if (res?.data?.diagnosisRule) {
      diagnosisForm.value = { ...res.data };
    } else {
      diagnosisForm.value = {
        factoryId: factoryId,
        diagnosisRule: new DiagnosisRule(),
      };
    }

    if (res?.data?.workWxSettings) {
      workWxForm.value = { ...res.data };
    } else {
      workWxForm.value = {
        factoryId: factoryId,
        workWxSettings: new WorkWxSettings(),
      };
    }

    if (res?.data?.reportRule) {
      reportRuleForm.value = { ...res.data };
    } else {
      reportRuleForm.value = {
        factoryId: factoryId,
        reportRule: new ReportRule(),
      };
    }
  });
};

const saveDiagnosisRules = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };

  diagnosisForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", diagnosisForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(diagnosisForm.value.factoryId!);
      }
    });
};

let factoryListAll: any = ref([]);
let boldList: any = ref([]);

let workWxForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "workWxSettings">
>({
  id: null,
  factoryId: null,
  workWxSettings: new WorkWxSettings(),
});

const saveWorkWxForm = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  workWxForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", workWxForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(workWxForm.value.factoryId!);
      }
    });
};

// 保存
const saveReportRuleSettings = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };

  reportRuleForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", reportRuleForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(reportRuleForm.value.factoryId!);
      }
    });
};

let reportRuleForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "reportRule">
>({
  id: null,
  factoryId: null,
  reportRule: new ReportRule(),
});
let factoryList = ref<any>();

let systemInfo = ref<any>({
  id: null,
  captcha: true,
  errorPwdLock: true,
  errorPwdCount: 3,
  errorPwdLockSecond: 300,
  autoLogout: true,
  autoLogoutSecond: 1800,
  pwdExpireDay: 180,
  pwdHistory: false,
  pwdHistoryDay: 180,
  opcUASettings: {
    url: "",
    userName: "",
    password: "",
  },
});

const loadFactory = () => {
  const config = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      factoryListAll.value = JSON.parse(JSON.stringify(res.data));
      console.log("factoryListAll.value", factoryListAll.value);
      let childFactories = res.data.filter((t: any) => t.parentId);
      let parentIds = res.data
        .filter((t: any) => t.parentId)
        .map((t: any) => t.parentId);

      if (childFactories.length) {
        boldList.value = res.data.filter((t: any) => !t.parentId);
        factoryList.value = res.data.filter(
          (t: any) => !parentIds.includes(t._id)
        );
      } else {
        factoryList.value = res.data;
        boldList.value = factoryList.value;
      }
      getFactorySettings(factoryList.value[0]._id);
    }
  });
};

const deleteGroup = (list: any, index: any) => {
  list.splice(index, 1);
};

const addGroup = (list: any) => {
  list.push({
    sonID: new Date().getTime().toString(),
    name: "",
  });
};

const addFactory = () => {
  factoryListAll.value.push({
    createAt: transformDate(new Date()),
    factoryName: "",
    groups: [],
    parentId: "",
  });
};

const deleteFactory = async (index: any) => {
  let factory = factoryListAll.value[index];

  let children = factoryListAll.value.filter(
    (t: any) => t.parentId == factory._id
  );
  if (children.length) {
    message.warning("请先删除子工厂");
    return;
  }

  let res = await request.delete(`/api/factories`, {
    params: { id: factory._id },
  });
  if (res && res.status == 200) {
    message.success("删除工厂成功");
    factoryListAll.value.splice(index, 1);
    let idx = factoryList.value.findIndex((t: any) => t._id == factory._id);
    if (idx >= 0) {
      factoryList.value.splice(idx, 1);
    }
  }
};

const saveFactory = async () => {
  let list = JSON.parse(JSON.stringify(factoryListAll.value));

  for (let d of list) {
    if (!d.factoryName) {
      message.success("请填写工厂名称!");
      return;
    }
    if (d.groups && d.groups.length) {
      for (let g of d.groups) {
        if (!g.name) {
          message.success("请填写区域名称!");
          return;
        }
      }
    }
  }

  let result = await request.post("/api/factories", list);
  if (result && result.status == 200) {
    message.success(getLanguage("操作成功"));
    // 请求/api/member/info刷新人员的工厂权限缓存
    await request.get("/api/members/info");
    loadFactory();
  } else {
    message.success("操作失败");
  }
};

let loadSystemSetting = async () => {
  const config = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/system/setting", config);
  if (result.data) {
    if (!result.data.opcUASettings) {
      result.data.opcUASettings = {
        url: "",
        userName: "",
        password: "",
      };
    }
    systemInfo.value = result.data;
  }
};

const saveSystemSetting = async () => {
  let result = await request.post("/api/system/setting", systemInfo.value);
  if (result && result.status == 200) {
    message.success(getLanguage("操作成功"));
    loadSystemSetting();
  } else {
    message.success("操作失败");
  }
};

onMounted(() => {
  loadFactory();
  loadSystemSetting();
});
</script>
<style scoped>
.code-box-description {
  padding-bottom: 0;
}

.code-box {
  position: relative;
  display: inline-block;
  width: 90%;
  margin: 0 0px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  transition: all 0.2s;
  padding: 15px;
}

.main {
  margin-top: 30px;
}

.bigFont {
  font-size: 22px;
  font-weight: 700;
}

.freqx_tips {
  margin-top: 4px;
}

.facInfo {
  border: 1px solid gray;
}

.fac-box {
  border: 1px solid rgba(128, 128, 128, 0.384);
}

.fff {
  color: #fff;
}
</style>
